module.exports = __webpack_public_path__ + "static/media/party-hat.1e7bdc55.svg";